var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64645 7.85355C3.84171 8.04882 4.15829 8.04882 4.35355 7.85355L7.85355 4.35355C8.04882 4.15829 8.04882 3.84171 7.85355 3.64645C7.65829 3.45118 7.34171 3.45118 7.14645 3.64645L4.5 6.29289V0.5C4.5 0.223857 4.27614 0 4 0C3.72386 0 3.5 0.223857 3.5 0.5V6.29289L0.853553 3.64645C0.658291 3.45118 0.341709 3.45118 0.146447 3.64645C-0.0488155 3.84171 -0.0488155 4.15829 0.146447 4.35355L3.64645 7.85355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderArrow);
export default __webpack_public_path__ + "static/media/orderArrow.8ef18a801ab73bf5c612c6f05c9af4a7.svg";
export { ForwardRef as ReactComponent };